import React from "react";

const PlusIconLight = () => {
  return (
    <>
      <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.997 2.292c.576 0 1.042.466 1.042 1.042v5.625h5.625a1.042 1.042 0 010 2.083H11.04v5.625a1.042 1.042 0 01-2.083 0v-5.625H3.33a1.042 1.042 0 010-2.083h5.625V3.334c0-.576.466-1.042 1.041-1.042z"
        fill="#344054"
      />
    </svg>
    </>
  );
};

export default PlusIconLight;
